import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthProvider';

/** Route guard. Everything except /signin sits behind it. */
export function RequireAuth() {
  const { session, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="grid h-full place-items-center text-base text-ink-muted">
        {t('auth.checking')}
      </div>
    );
  }

  if (!session) {
    // `from` so the dispatcher lands back where he was aiming, not on the dashboard.
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
